"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/BrandingTab/ColourField.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _brandPalette = require('shared/services/brandPalette');

/* The brand colour: a picker and a #RRGGBB field, reset to BloomText
 * purple (no colour saved), and the three derived colours with their
 * contrast ratios. When the picked colour is too light to read, one line
 * says it was darkened. */

 const BLOOMTEXT_PURPLE = '#6257C4'; exports.BLOOMTEXT_PURPLE = BLOOMTEXT_PURPLE
const INK = '#3B3A48'
const WHITE = '#FFFFFF'






const ratio = (a, b) => `${_brandPalette.contrastRatio.call(void 0, a, b).toFixed(1)}:1`

const Swatch = ({ label, colour, ratioText }) => (
  _react2.default.createElement('div', { className: "branding-colour--swatch", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    , _react2.default.createElement('span', { className: "branding-colour--chip", style: { background: colour }, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}} )
    , _react2.default.createElement('span', { className: "branding-colour--swatch-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      , _react2.default.createElement('span', { className: "branding-colour--swatch-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  label )
      , _react2.default.createElement('span', { className: "branding-colour--swatch-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  colour , " · "  ,  ratioText )
    )
    /* The palette always meets the ratios (4.5:1 text, 3:1 controls). */
    , _react2.default.createElement('i', { className: "material-icons branding-colour--check" , role: "img", 'aria-label': "Readable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "check")
  )
)

const ColourField = ({ value, onChange }) => {
  const palette = _react.useMemo.call(void 0, () => _nullishCoalesce(_brandPalette.brandPalette.call(void 0, value), () => ( _brandPalette.brandPalette.call(void 0, exports.BLOOMTEXT_PURPLE))), [value])
  const isValid = !value || !!_brandPalette.brandPalette.call(void 0, value)
  const onText = _react.useCallback.call(void 0, (e) => onChange(e.target.value.trim()), [onChange])
  const onPicker = _react.useCallback.call(void 0, (e) => onChange(e.target.value.toUpperCase()), [onChange])
  const reset = _react.useCallback.call(void 0, () => onChange(''), [onChange])

  return (
    _react2.default.createElement('div', { className: "branding-colour", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement('div', { className: "branding-colour--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        , _react2.default.createElement('input', {
          type: "color",
          className: "branding-colour--picker",
          'aria-label': "Pick brand colour"  ,
          value: (_brandPalette.brandPalette.call(void 0, value) ? value : exports.BLOOMTEXT_PURPLE).toLowerCase(),
          onChange: onPicker, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        )
        , _react2.default.createElement('input', {
          type: "text",
          className: "blm-text-input branding-colour--hex" ,
          'aria-label': "Brand colour (hex)"  ,
          'aria-invalid': !isValid,
          placeholder: exports.BLOOMTEXT_PURPLE,
          maxLength: 7,
          value: value,
          onChange: onText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        )
        , _react2.default.createElement('button', { type: "button", className: "branding-colour--reset", onClick: reset, disabled: !value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Reset to BloomText purple"

        )
      )
      ,  !isValid && _react2.default.createElement('p', { className: "branding-colour--note branding-colour--invalid" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Enter a colour as #RRGGBB, for example #12665E."       ) 
      , _react2.default.createElement('div', { className: "branding-colour--swatches", role: "group", 'aria-label': "Derived colours" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        , _react2.default.createElement(Swatch, { label: "Buttons, links" , colour: palette.accent, ratioText: ratio(palette.accent, WHITE), __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
        , _react2.default.createElement(Swatch, { label: "Your messages" , colour: palette.bubble, ratioText: ratio(INK, palette.bubble), __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}} )
        , _react2.default.createElement(Swatch, { label: "Reply strip" , colour: palette.replyStrip, ratioText: ratio(INK, palette.replyStrip), __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} )
      )
      ,  isValid && value && palette.darkened && (
        _react2.default.createElement('p', { className: "branding-colour--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
          ,  value.toUpperCase() , " is too light to read on white, so buttons and links use "             ,  palette.accent , ", darkened for readability."
        )
      )
    )
  )
}

exports. default = ColourField
